import { Link as RouterLink } from "@tanstack/react-router"
import { forwardRef, type AnchorHTMLAttributes } from "react"

type LinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string
}

function isDocumentLink(href: string): boolean {
  return href.startsWith("#") || /^(https?:|mailto:|tel:)/i.test(href)
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  { href, children, ...props },
  ref,
) {
  if (isDocumentLink(href)) {
    return (
      <a ref={ref} href={href} {...props}>
        {children}
      </a>
    )
  }

  return (
    <RouterLink ref={ref} to={href} {...props}>
      {children}
    </RouterLink>
  )
})

export default Link
